import { create } from 'zustand';
import type { SessionUser } from '@/shared/types';

interface SessionState {
  user: SessionUser | null;
  hydrated: boolean;
  setUser: (u: SessionUser | null) => void;
  setHydrated: (v: boolean) => void;
  reset: () => void;
}

export const useSession = create<SessionState>((set) => ({
  user: null,
  hydrated: false,
  setUser: (user) => set({ user }),
  setHydrated: (hydrated) => set({ hydrated }),
  reset: () => set({ user: null, hydrated: true }),
}));
